import { ViewConfig } from "../../../components"
import { readViewRequestForm, deleteViewRequestForm, editViewRequestForm, searchViewRequestForm, newViewRequestForm,
  readViewStatus, searchViewStatus, editViewStatus, newViewStatus, deleteViewStatus } from "../../../components/Forms"
import { validators } from "react-ocean-forms"
import { ViewMode } from "../../../components/Common/ViewMode"


export const searchView: ViewConfig = {
  viewName: ViewMode.Search,
  fields: {
    parametercode: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        // @ts-ignore
        validators: [validators.withParam(validators.maxLength, 255)],
      },
    },
    parametername: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        // @ts-ignore
        validators: [validators.withParam(validators.maxLength, 700)],
      },
    },
    alternativname: {
      field: {
        disabled: false,
        hidden: true,
        plaintext: false,
      },
    },
    dimension: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    material: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    non_material: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    unit: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    sample_pretreatment: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    method: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    other_criterion: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    matrix: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    ...searchViewRequestForm,
    ...searchViewStatus,
  }

}

export const deleteView: ViewConfig = {
  viewName: ViewMode.Delete,
  fields: {
    parametercode: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    parametername: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
        // @ts-ignore
        validators: [validators.withParam(validators.maxLength, 700)],
      },
    },
    alternativname: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    dimension: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    material: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    non_material: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    unit: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    sample_pretreatment: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    method: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    other_criterion: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    matrix: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    ...deleteViewRequestForm,
    ...deleteViewStatus,
  }
}

export const readView: ViewConfig = {
  viewName: ViewMode.Read,
  fields: {
    parametercode: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: true,
        // @ts-ignore
        validators: [validators.withParam(validators.maxLength, 255)],
      },
    },
    parametername: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: true,
        // @ts-ignore
        validators: [validators.withParam(validators.maxLength, 700)],
      },
    },
    alternativname: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: true,
      },
    },
    dimension: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: true,
      },
    },
    material: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: true,
      },
    },
    non_material: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: true,
      },
    },
    unit: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: true,
      },
    },
    sample_pretreatment: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: true,
      },
    },
    method: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: true,
      },
    },
    other_criterion: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: true,
      },
    },
    matrix: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: true,
      },
    }, 
    ...readViewRequestForm,
    ...readViewStatus,
  }
}



export const editView: ViewConfig = {
  viewName: ViewMode.Edit,
  fields: {
    parametercode: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
        // @ts-ignore
        validators: [validators.withParam(validators.maxLength, 700)],
      },
    },
    parametername: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        // @ts-ignore
        validators: [validators.withParam(validators.maxLength, 700), validators.required],
      },
    },
    alternativname: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    dimension: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
        validators: [validators.required],
      },
    },

    material: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    non_material: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    unit: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        validators: [validators.required],
      },
    },
    sample_pretreatment: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        validators: [validators.required],
      },
    },
    method: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    other_criterion: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    matrix: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    ...editViewRequestForm,
    ...editViewStatus,
  }
}

export const newView: ViewConfig = {
  viewName: ViewMode.New,
  fields: {
    parametercode: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
        // @ts-ignore
        validators: [validators.withParam(validators.maxLength, 255)],
      },
    },
    parametername: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        // @ts-ignore
        validators: [validators.withParam(validators.maxLength, 700), validators.required],
      },
    },
    alternativname: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    dimension: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
        validators: [validators.required],
      },
    },

    material: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    non_material: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    unit: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        validators: [validators.required],
      },
    },
    sample_pretreatment: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        validators: [validators.required],
      },
    },
    method: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    other_criterion: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    matrix: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    ...newViewRequestForm,
    ...newViewStatus,
  }
}
